<template lang="pug">
div
  UiCardSection
    .ui-card-section-title {{ $t("admin_tools.tabs.company_logs") }}
  UiCardSection
    RestTable(
      namespace="logs"
      :headers="headers"
      ref="logsTable"
      :fetch-handler="getData"
      :initial-filters="initialFilters"
      embed
    )
      template(#filters="{ filters, updateFilters }")
        UiStack
          UiStackItem(fill)
            UiFormGroup(:label="$t('admin_tools.logs.model')")
              UiMultiselect(
                :modelValue="filters.model"
                :options="modelsOptions"
                @update:modelValue="updateFilters({ model: $event })"
                :canClear="false"
                :canDeselect="false"
              )
          UiStackItem(fill)
            UiFormGroup(:label="$t('admin_tools.logs.record_id')")
              UiInput(
                :modelValue="filters.record_id"
                type="search"
                @update:modelValue="updateFilters({ record_id: $event })"
              )
          UiStackItem(fill)
            UiFormGroup(:label="$t('companies.automation.start_date')")
              UiDatePicker(
                :modelValue="new Date(filters.start_date)"
                @update:modelValue="updateFilters({ start_date: startOfDay($event) })"
              )
          UiStackItem(fill)
            UiFormGroup(:label="$t('companies.automation.end_date')")
              UiDatePicker(
                :modelValue="new Date(filters.end_date)"
                @update:modelValue="updateFilters({ end_date: endOfDay($event) })"
              )
</template>

<script>
import ApiLogs from "@/api/logs.js";
import { addMonths } from "@/common/date_utils";
import { endOfDay, startOfDay } from "@bi-book/bibook-ui-kit";

export default {
  data() {
    const startDate = startOfDay(addMonths(new Date(), -1));
    const endDate = endOfDay(new Date());
    return {
      modelsOptions: [
        { value: "all", label: "All" },
        { value: "Company", label: "Company" },
        { value: "CompanyFeature", label: "CompanyFeature" },
      ],
      initialFilters: {
        model: "all",
        record_id: "",
        company_name: "",
        start_date: startDate.toISOString(),
        end_date: endDate.toISOString(),
      },
      headers: [
        {
          key: "id",
          label: "#",
          sortable: true,
          squeeze: true,
        },
        {
          key: "username",
          label: "Username",
          sortable: true,
        },
        {
          key: "model",
          label: "Model",
          sortable: true,
        },
        {
          key: "record_id",
          label: "Record Id",
          sortable: true,
        },
        {
          key: "created_at",
          label: "Date",
          sortable: true,
        },
        {
          key: "record_changes",
          label: "Record Changes",
          sortable: true,
        },
        {
          key: "comment",
          label: "Comment",
          sortable: true,
        },
        {
          key: "actions",
          label: "",
          squeeze: true,
        },
      ],
    };
  },

  methods: {
    startOfDay: startOfDay,
    endOfDay: endOfDay,
    getData(params, config) {
      return ApiLogs.fetchLogs(
        { ...params, model: params.model === "all" ? null : params.model },
        config,
      ).then((resp) => {
        return {
          items: resp.data.logs,
          meta: resp.data.meta,
        };
      });
    },
  },
};
</script>
